// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Dashboard$ReactHooksTemplate = require("./dashboard.res.js");
var CheckboxInput$ReactHooksTemplate = require("../../common/CheckboxInput.res.js");
var DashboardShare$ReactHooksTemplate = require("./dashboardShare.res.js");

function DashboardShareForm(props) {
  var onClose = props.onClose;
  var dashboard = props.dashboard;
  var initialState_dashboardShares = props.dashboardShares;
  var initialState = {
    dashboardShares: initialState_dashboardShares,
    deletedDashboardShares: /* [] */0,
    newDashboardShares: /* [] */0,
    resourceType: undefined,
    searchKey: undefined,
    users: /* [] */0,
    roles: /* [] */0,
    notification: undefined
  };
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchUsers = function (param) {
    Js_promise.then_((function (users) {
            return Promise.resolve(Curry._1(setState, (function (param) {
                              return {
                                      dashboardShares: state.dashboardShares,
                                      deletedDashboardShares: state.deletedDashboardShares,
                                      newDashboardShares: state.newDashboardShares,
                                      resourceType: state.resourceType,
                                      searchKey: state.searchKey,
                                      users: users,
                                      roles: state.roles,
                                      notification: state.notification
                                    };
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/users", (function (param) {
                return Json_decode.field("users", (function (param) {
                              return Json_decode.list(DashboardShare$ReactHooksTemplate.decodeUser, param);
                            }), param);
              })));
  };
  var fetchRoles = function (param) {
    Js_promise.then_((function (roles) {
            return Promise.resolve(Curry._1(setState, (function (param) {
                              return {
                                      dashboardShares: state.dashboardShares,
                                      deletedDashboardShares: state.deletedDashboardShares,
                                      newDashboardShares: state.newDashboardShares,
                                      resourceType: state.resourceType,
                                      searchKey: state.searchKey,
                                      users: state.users,
                                      roles: roles,
                                      notification: state.notification
                                    };
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/roles", (function (param) {
                return Json_decode.field("roles", (function (param) {
                              return Json_decode.list(DashboardShare$ReactHooksTemplate.decodeRole, param);
                            }), param);
              })));
  };
  var removeShare = function (dashboardShare) {
    var remainingDashboardShares = Belt_List.keep(state.dashboardShares, (function (x) {
            return Caml_obj.notequal(DashboardShare$ReactHooksTemplate.id(x), DashboardShare$ReactHooksTemplate.id(dashboardShare));
          }));
    var deletedDashboardShares = List.append(state.deletedDashboardShares, {
          hd: dashboardShare,
          tl: /* [] */0
        });
    Curry._1(setState, (function (param) {
            return {
                    dashboardShares: remainingDashboardShares,
                    deletedDashboardShares: deletedDashboardShares,
                    newDashboardShares: state.newDashboardShares,
                    resourceType: state.resourceType,
                    searchKey: state.searchKey,
                    users: state.users,
                    roles: state.roles,
                    notification: state.notification
                  };
          }));
  };
  React.useEffect((function (param) {
          var resourceType = state.resourceType;
          if (resourceType === undefined) {
            return ;
          }
          if (resourceType === "Role") {
            var match = state.roles;
            if (match) {
              
            } else {
              fetchRoles();
            }
          } else {
            var match$1 = state.users;
            if (match$1) {
              
            } else {
              fetchUsers();
            }
          }
        }), [state.resourceType]);
  var match$1 = state.resourceType;
  var tmp;
  if (match$1 !== undefined) {
    var match$2 = state.resourceType;
    var tmp$1;
    tmp$1 = match$2 !== undefined ? (
        match$2 === "Role" ? $$Array.of_list(List.map((function (role) {
                      return JsxRuntime.jsx("option", {
                                  children: role.name,
                                  value: role.name
                                }, String(role.id));
                    }), state.roles)) : $$Array.of_list(List.map((function (user) {
                      return JsxRuntime.jsx("option", {
                                  children: user.email,
                                  value: user.email
                                }, String(user.id));
                    }), state.users))
      ) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
    var partial_arg = state.resourceType;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: "Select " + (Belt_Option.getWithDefault(state.resourceType, "") + ":"),
                  className: "mt-2 font-medium text-base w-3/11"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("select", {
                        children: tmp$1,
                        className: "block border px-3 py-2 border-gray-400\n                        bg-white rounded capitalize mr-6 text-sm w-full",
                        onChange: (function (param) {
                            var selectedName = param.target.value;
                            if (partial_arg === undefined) {
                              return ;
                            }
                            if (partial_arg === "Role") {
                              var newDashboardShares = Belt_List.concat({
                                    hd: {
                                      id: undefined,
                                      resourceType: {
                                        TAG: "Role",
                                        _0: List.find((function (x) {
                                                return x.name === selectedName;
                                              }), state.roles)
                                      }
                                    },
                                    tl: /* [] */0
                                  }, state.newDashboardShares);
                              return Curry._1(setState, (function (param) {
                                            return {
                                                    dashboardShares: state.dashboardShares,
                                                    deletedDashboardShares: state.deletedDashboardShares,
                                                    newDashboardShares: newDashboardShares,
                                                    resourceType: state.resourceType,
                                                    searchKey: state.searchKey,
                                                    users: state.users,
                                                    roles: state.roles,
                                                    notification: state.notification
                                                  };
                                          }));
                            }
                            var newDashboardShares$1 = Belt_List.concat({
                                  hd: {
                                    id: undefined,
                                    resourceType: {
                                      TAG: "User",
                                      _0: List.find((function (x) {
                                              return x.email === selectedName;
                                            }), state.users)
                                    }
                                  },
                                  tl: /* [] */0
                                }, state.newDashboardShares);
                            return Curry._1(setState, (function (param) {
                                          return {
                                                  dashboardShares: state.dashboardShares,
                                                  deletedDashboardShares: state.deletedDashboardShares,
                                                  newDashboardShares: newDashboardShares$1,
                                                  resourceType: state.resourceType,
                                                  searchKey: state.searchKey,
                                                  users: state.users,
                                                  roles: state.roles,
                                                  notification: state.notification
                                                };
                                        }));
                          })
                      }),
                  className: "mt-2 font-medium text-base w-3/6"
                })
          ],
          className: "flex items-center"
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Share Dashboard"
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "h-14-px float-right cursor-pointer",
                                    src: Image$ReactHooksTemplate.closeIcon,
                                    onClick: onClose
                                  })
                            ],
                            className: "p-8 text-lg font-bold flex justify-between"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("p", {
                                                                children: "Share Dashboard with: ",
                                                                className: "w-3/11"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                        checked: Belt_Option.getWithDefault(state.resourceType, "") === "Role",
                                                                        label: "Role",
                                                                        handleChange: (function (param) {
                                                                            if (Belt_Option.getWithDefault(state.resourceType, "") === "Role") {
                                                                              return Curry._1(setState, (function (param) {
                                                                                            return {
                                                                                                    dashboardShares: state.dashboardShares,
                                                                                                    deletedDashboardShares: state.deletedDashboardShares,
                                                                                                    newDashboardShares: state.newDashboardShares,
                                                                                                    resourceType: undefined,
                                                                                                    searchKey: state.searchKey,
                                                                                                    users: state.users,
                                                                                                    roles: state.roles,
                                                                                                    notification: state.notification
                                                                                                  };
                                                                                          }));
                                                                            } else {
                                                                              return Curry._1(setState, (function (param) {
                                                                                            return {
                                                                                                    dashboardShares: state.dashboardShares,
                                                                                                    deletedDashboardShares: state.deletedDashboardShares,
                                                                                                    newDashboardShares: state.newDashboardShares,
                                                                                                    resourceType: "Role",
                                                                                                    searchKey: state.searchKey,
                                                                                                    users: state.users,
                                                                                                    roles: state.roles,
                                                                                                    notification: state.notification
                                                                                                  };
                                                                                          }));
                                                                            }
                                                                          }),
                                                                        indeterminate: false,
                                                                        className: "mr-3"
                                                                      }),
                                                                  JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                        checked: Belt_Option.getWithDefault(state.resourceType, "") === "User",
                                                                        label: "User",
                                                                        handleChange: (function (param) {
                                                                            if (Belt_Option.getWithDefault(state.resourceType, "") === "User") {
                                                                              return Curry._1(setState, (function (param) {
                                                                                            return {
                                                                                                    dashboardShares: state.dashboardShares,
                                                                                                    deletedDashboardShares: state.deletedDashboardShares,
                                                                                                    newDashboardShares: state.newDashboardShares,
                                                                                                    resourceType: undefined,
                                                                                                    searchKey: state.searchKey,
                                                                                                    users: state.users,
                                                                                                    roles: state.roles,
                                                                                                    notification: state.notification
                                                                                                  };
                                                                                          }));
                                                                            } else {
                                                                              return Curry._1(setState, (function (param) {
                                                                                            return {
                                                                                                    dashboardShares: state.dashboardShares,
                                                                                                    deletedDashboardShares: state.deletedDashboardShares,
                                                                                                    newDashboardShares: state.newDashboardShares,
                                                                                                    resourceType: "User",
                                                                                                    searchKey: state.searchKey,
                                                                                                    users: state.users,
                                                                                                    roles: state.roles,
                                                                                                    notification: state.notification
                                                                                                  };
                                                                                          }));
                                                                            }
                                                                          }),
                                                                        indeterminate: false,
                                                                        className: ""
                                                                      })
                                                                ],
                                                                className: "flex items-center"
                                                              })
                                                        ],
                                                        className: "flex items-center"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("div", {
                                                              children: tmp,
                                                              className: "pb-16 pt-2 border-gray-200 text-base font-medium"
                                                            })
                                                      })
                                                ],
                                                className: "flex flex-col w-full"
                                              })
                                        }),
                                    JsxRuntime.jsxs("table", {
                                          children: [
                                            JsxRuntime.jsx("thead", {
                                                  children: JsxRuntime.jsxs("tr", {
                                                        children: [
                                                          JsxRuntime.jsx("th", {
                                                                children: "Who has access",
                                                                className: "w-3/6 py-2"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                children: "Type",
                                                                className: "w-2/6 py-2"
                                                              }),
                                                          JsxRuntime.jsx("th", {
                                                                className: "w-1/6 py-2"
                                                              })
                                                        ]
                                                      })
                                                }),
                                            JsxRuntime.jsx("tbody", {
                                                  children: $$Array.of_list(List.map((function (x) {
                                                              var role = DashboardShare$ReactHooksTemplate.resourceType(x);
                                                              if (role.TAG === "Role") {
                                                                return JsxRuntime.jsxs("tr", {
                                                                            children: [
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: role._0.name,
                                                                                    className: "w-3/6 py-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: "Role",
                                                                                    className: "w-2/6 py-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: JsxRuntime.jsx("button", {
                                                                                          children: JsxRuntime.jsx("img", {
                                                                                                className: "w-3",
                                                                                                src: Image$ReactHooksTemplate.closeIcon
                                                                                              }),
                                                                                          id: "filter_reset",
                                                                                          style: {
                                                                                            outline: "None"
                                                                                          },
                                                                                          onClick: (function (param) {
                                                                                              removeShare(x);
                                                                                            })
                                                                                        }),
                                                                                    className: "w-1/6 py-2"
                                                                                  })
                                                                            ],
                                                                            className: ""
                                                                          });
                                                              } else {
                                                                return JsxRuntime.jsxs("tr", {
                                                                            children: [
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: role._0.email,
                                                                                    className: "w-3/6 py-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: "User",
                                                                                    className: "w-2/6 py-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: JsxRuntime.jsx("button", {
                                                                                          children: JsxRuntime.jsx("img", {
                                                                                                className: "w-3",
                                                                                                src: Image$ReactHooksTemplate.closeIcon
                                                                                              }),
                                                                                          id: "filter_reset",
                                                                                          style: {
                                                                                            outline: "None"
                                                                                          },
                                                                                          onClick: (function (param) {
                                                                                              removeShare(x);
                                                                                            })
                                                                                        }),
                                                                                    className: "w-1/6 py-2"
                                                                                  })
                                                                            ]
                                                                          });
                                                              }
                                                            }), state.dashboardShares)),
                                                  className: "text-center border py-2"
                                                })
                                          ],
                                          className: "w-full px-30 border"
                                        })
                                  ],
                                  className: "py-10 p-8 border-t border-gray-200 text-base font-medium"
                                }),
                            className: "overflow-y-auto",
                            style: {
                              height: "calc(100vh - 40rem)"
                            }
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Discard",
                                    className: "bg-ghostwhite border border-gray-400\n                  flex rounded py-3 px-6 text-xs",
                                    id: "close_modal",
                                    onClick: onClose
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Share",
                                    className: "bg-palatinateblue border border-gray-400\n                  flex rounded py-3 px-6 text-xs text-white",
                                    id: "save",
                                    onClick: (function (param) {
                                        var partial_arg = true;
                                        var deletedDashboardShares = Belt_List.map(state.deletedDashboardShares, (function (param) {
                                                return DashboardShare$ReactHooksTemplate.encode(partial_arg, param);
                                              }));
                                        var newDashboardShares = Belt_List.map(state.newDashboardShares, (function (x) {
                                                return DashboardShare$ReactHooksTemplate.encode(undefined, x);
                                              }));
                                        var params = Json_encode.object_({
                                              hd: [
                                                "dashboard_shares_attributes",
                                                Belt_List.toArray(List.append(deletedDashboardShares, newDashboardShares))
                                              ],
                                              tl: /* [] */0
                                            });
                                        Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", Json_decode.string, response);
                                                if (status === "success") {
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dashboardShares: Json_decode.field("dashboard_shares", (function (param) {
                                                                          return Json_decode.list(DashboardShare$ReactHooksTemplate.decode, param);
                                                                        }), response),
                                                                  deletedDashboardShares: /* [] */0,
                                                                  newDashboardShares: /* [] */0,
                                                                  resourceType: state.resourceType,
                                                                  searchKey: state.searchKey,
                                                                  users: state.users,
                                                                  roles: state.roles,
                                                                  notification: [
                                                                    "Access updated",
                                                                    false
                                                                  ]
                                                                };
                                                        }));
                                                } else {
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dashboardShares: state.dashboardShares,
                                                                  deletedDashboardShares: state.deletedDashboardShares,
                                                                  newDashboardShares: state.newDashboardShares,
                                                                  resourceType: state.resourceType,
                                                                  searchKey: state.searchKey,
                                                                  users: state.users,
                                                                  roles: state.roles,
                                                                  notification: [
                                                                    "Updation\n           failed. Please contact Admin",
                                                                    true
                                                                  ]
                                                                };
                                                        }));
                                                }
                                                return Promise.resolve();
                                              }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/dashboards/" + (String(Dashboard$ReactHooksTemplate.id(dashboard)) + "/share"), params));
                                      })
                                  })
                            ],
                            className: "p-8 flex border-t border-gray-200 justify-end gap-3 font-medium\n                bottom-0 text-base w-full"
                          })
                    ],
                    className: "bg-white modal-dialog z-10 shadow relative\n                      border border-gray-300 pointer-events-auto w-3/6 min-h-1/2"
                  }),
              className: "w-screen z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
              style: {
                height: "calc(100vh + 5rem)"
              }
            });
}

var make = DashboardShareForm;

exports.make = make;
/* react Not a pure module */
